module.exports = __webpack_public_path__ + "img/icon-nav4.16fd6e5c.svg";